"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContextMenuContext = exports.ContextMenuContext = exports.getSubMenuContext = exports.SubMenuContext = exports.getMenuItemContext = exports.MenuItemContext = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var helper_1 = require("../../utils/helper");
exports.MenuItemContext = React.createContext({
    itemStyle: undefined,
    clickHandler: helper_1.emptyFn,
    selectedIds: [],
});
exports.getMenuItemContext = helper_1.createContextValueGetter();
exports.SubMenuContext = React.createContext({
    zIndex: 10000,
    visible: true,
    type: 'normal',
    horizontalPlacement: 'right',
    viewportMargin: 2,
});
exports.getSubMenuContext = helper_1.createContextValueGetter();
exports.ContextMenuContext = React.createContext({
    visible: true,
    onClick: helper_1.emptyFn,
});
exports.getContextMenuContext = helper_1.createContextValueGetter();
